'use client';

export default function EcoIconCheckboxY({ className, ...reset }: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 20 20"
            fill="none"
            className={`eco-icon-checkbox-y${className ? ` ${className}` : ''}`}
            {...reset}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.16667 2.5C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5H4.16667ZM14.6845 8.04252C14.9841 7.75651 14.9952 7.28177 14.7092 6.98214C14.4232 6.68252 13.9484 6.67148 13.6488 6.95748L8.44969 11.9203L6.36366 9.83425C6.07077 9.54136 5.5959 9.54136 5.303 9.83425C5.01011 10.1271 5.01011 10.602 5.303 10.8949L7.90717 13.4991C8.19526 13.7872 8.66065 13.7926 8.95536 13.5113L14.6845 8.04252Z"
                fill="#3F68E0"
            />
        </svg>
    );
}
